import React from 'react';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';
import { REDUCER_NAME } from '../../reducer';
import { connect } from 'react-redux';
import { SimpleTooltip } from '../../../../common/tooltip';

class HeaderMethod extends React.Component {
  render() {
    const { valuationStock, title, keyRecommend, tooltipTitle } = this.props;
    const { recommendMethod } = valuationStock;

    return (
      <div className="first-div-right">
        <span className="title-method">
          <Translate value={'valuation.method'} />
        </span>
        &nbsp;
        <span>{title}</span>
        <SimpleTooltip message={tooltipTitle} position={'right'}>
          <i
            style={{ opacity: 0.6, paddingLeft: 5, paddingRight: 5 }}
            className="icon-info fs-10"
          />
        </SimpleTooltip>
        {recommendMethod === keyRecommend && (
          <div className="recommended-box">
            {I18n.t('valuation.button.recommend')}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    valuationStock: state[REDUCER_NAME].valuationStock,
  };
};

HeaderMethod.propTypes = {
  title: PropTypes.string.isRequired,
  keyRecommend: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(HeaderMethod);
